import { initFaro } from './faro.js';
import { router } from './router.js';
import { HomePageHeader } from './components/HomePage/HomePageHeader.js';
import { initTooltips } from './utils/tooltips.js';

const MARKETING_SCROLL_STORAGE_KEY = 'marketing-scroll-position';

function initializeRoutes() {
    router.addRoute('/learn-more', async () => {
        window.homePageHeader?.updateNavButtons('learn-more');
        return new (await import('./components/LearnMore.js')).LearnMore();
    });
    router.addRoute('/apply', async (queryParams) => {
        window.homePageHeader?.updateNavButtons('apply');
        return new (await import('./components/ApplyPage.js')).ApplyPage(queryParams);
    });
    router.addRoute(
        '/apply/success',
        async () => new (await import('./components/ApplySuccessPage.js')).ApplySuccessPage()
    );
}

function persistScrollPosition() {
    const homePage = document.querySelector('.home-page');
    try {
        sessionStorage.setItem(
            MARKETING_SCROLL_STORAGE_KEY,
            JSON.stringify({
                path: window.location.pathname,
                scroller: homePage ? 'home-page' : 'window',
                scrollTop: homePage ? homePage.scrollTop : window.scrollY,
            })
        );
    } catch {
        // Storage can be unavailable in hardened browser contexts.
    }
}

async function restoreScrollPosition() {
    if (performance.getEntriesByType('navigation')[0]?.type !== 'reload') return;
    let snapshot;
    try {
        snapshot = JSON.parse(sessionStorage.getItem(MARKETING_SCROLL_STORAGE_KEY));
        sessionStorage.removeItem(MARKETING_SCROLL_STORAGE_KEY);
    } catch {
        return;
    }
    if (snapshot?.path !== window.location.pathname || typeof snapshot?.scrollTop !== 'number') return;
    await new Promise((resolve) => requestAnimationFrame(resolve));
    if (snapshot.scroller === 'home-page') {
        const homePage = document.querySelector('.home-page');
        if (homePage) homePage.scrollTop = snapshot.scrollTop;
    } else {
        window.scrollTo({ top: snapshot.scrollTop, behavior: 'auto' });
    }
}

async function initializeMarketingSite() {
    initFaro();
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    initializeRoutes();
    // PUBLIC_AUTHENTICATED is already resolved by the server, so nothing waits on the app here.
    window.homePageHeader = new HomePageHeader();
    await router.init();
    await restoreScrollPosition();
    window.router = router;
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMarketingSite);
} else {
    initializeMarketingSite();
}

window.addEventListener('beforeunload', persistScrollPosition);
window.addEventListener('pagehide', persistScrollPosition);
document.addEventListener('DOMContentLoaded', initTooltips);
